import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { api } from "../lib/api";

export default function AdminNewsletter() {
    const [items, setItems] = useState([]);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        api.get("/admin/newsletter").then(({ data }) => {
            setItems(data.items || []);
            setTotal(data.total || 0);
        });
    }, []);

    const exportCSV = async () => {
        try {
            const baseURL = api.defaults.baseURL;
            const token = api.defaults.headers.common["Authorization"];
            const resp = await fetch(`${baseURL}/admin/newsletter/export`, { headers: token ? { Authorization: token } : {} });
            const blob = await resp.blob();
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "sukaanyas-newsletter.csv";
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        } catch (_e) { /* ignore */ }
    };

    return (
        <div data-testid="admin-newsletter-page">
            <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
                <div>
                    <span className="label-eyebrow">Atelier letters</span>
                    <h1 className="mt-2 font-display text-4xl text-inkDark">Newsletter</h1>
                    <p className="mt-1 text-inkMuted">{total} {total === 1 ? "subscriber" : "subscribers"}.</p>
                </div>
                <button onClick={exportCSV} className="btn-pill text-sm" data-testid="admin-newsletter-export-button"><Download size={14} /> Export CSV</button>
            </div>

            <div className="mt-8 bg-ivory rounded-2xl border border-inkDark/5 overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full text-sm" data-testid="admin-newsletter-table">
                        <thead className="bg-beige text-inkMuted">
                            <tr>
                                <th className="text-left px-4 py-3 font-medium">Email</th>
                                <th className="text-left px-4 py-3 font-medium">Source</th>
                                <th className="text-left px-4 py-3 font-medium">Subscribed</th>
                                <th className="text-left px-4 py-3 font-medium">Unsubscribed</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((s) => (
                                <tr key={s.id} className="border-t border-inkDark/5">
                                    <td className="px-4 py-3 text-inkDark font-medium">{s.email}</td>
                                    <td className="px-4 py-3 text-inkMuted">{s.source}</td>
                                    <td className="px-4 py-3 text-inkMuted">{s.createdAt ? new Date(s.createdAt).toLocaleDateString() : "—"}</td>
                                    <td className="px-4 py-3">
                                        <span className={`text-[10px] px-2 py-1 rounded-full ${s.unsubscribed ? "bg-red-50 text-red-700" : "bg-green-50 text-green-700"}`}>
                                            {s.unsubscribed ? "Yes" : "No"}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                            {items.length === 0 ? <tr><td colSpan={4} className="px-4 py-10 text-center text-inkMuted">No subscribers yet.</td></tr> : null}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
